import { SET_ACTIVE_STEP } from '../../constants/workflows';

export const SetActiveStep = (options:any) => async (dispatch: any) => {
  try {
    dispatch({ type: SET_ACTIVE_STEP, payload: options });
  } catch (error: any) {
    console.log(error.data);
  }
};
